const PIXEL_ID = '1960727601200983'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

let initialized = false

function ensureFbq() {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
}

function loadPixelScript() {
  if (document.getElementById('fb-pixel-script')) return

  const script = document.createElement('script')
  script.id = 'fb-pixel-script'
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

function fbq(...args: unknown[]) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq(...args)
  }
}

export function initPixel() {
  if (initialized) return
  ensureFbq()
  loadPixelScript()
  fbq('init', PIXEL_ID)
  fbq('track', 'PageView')
  initialized = true
}

export function trackPageView() {
  fbq('track', 'PageView')
}

export function trackLead() {
  fbq('track', 'Lead')
}

export function trackCtaClick(ctaName: string) {
  fbq('trackCustom', 'CTAClick', {
    cta_name: ctaName,
    page: 'landing_page',
  })
}

export function trackVideoPlay() {
  fbq('track', 'ViewContent', {
    content_name: 'VSL Video',
    content_type: 'video',
    content_category: 'Sales Video',
  })
}

export function trackFormStart() {
  fbq('trackCustom', 'FormStart', {
    form_name: 'Strategy Call Application',
    page: 'landing_page',
  })
}
